module.exports = __webpack_public_path__ + "img/倒數開始_3.4e5215f5.png";